import { Controller } from './stimulus-controller-shim'
import RailsNestedForm from '@stimulus-components/rails-nested-form'

export default class extends RailsNestedForm { }
